import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { table } from "../../../../data/mock/table";
import { message } from "antd";

export const UseFetchInputs = () => {
  return useQuery(
    ["getFetchInput"],
    async (value) => {
      try {
        const endpoint = `/api/v1/input/list`;
        const { result } = await GET(endpoint);
        //const { result } = tableBank
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Input..");
      }
    }
  );
};

export const useFetchListInputReject = () => {
  return useQuery(
    ["getFetchListInputReject"],
    async (value) => {
      try {
        const endpoint = `/api/v1/input/listReject`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load List Input Reject..");
      }
    }
  );
};

export const useFetchListInput = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/input/list`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};



export const UseFetchInputsByPageAndLimit = ({page, limit}) => {
  return useQuery(
    ["getFetchInputByPageAndLimit", page, limit],
    async () => {
      try {
        console.log(page, limit);
        const endpoint = `/api/v1/input/list/${page}/${limit}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Input By Page And Limit..");
      }
    }
  );
};

export const UseFetchCreatePanelInput = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/input/panel`;
      const result = POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Create Input..");
    }
  });
}


// export const UseFetchCreateInput = () => {
//   return useMutation(async (payload) => {
//     try {
//       const endPoint = `/api/v1/input`;
//       const result = POST(endPoint, payload);
//       return result;
//     } catch (error) {
//       await message.destroy();
//       message.error("Failed To Create Input..");
//     }
//   });
// };

export const UseFetchCreateInput = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/input`;
      // หมายเหตุ: POST(path, obj, token) — arg ที่ 3 คือ token ไม่ใช่ options
      // เดิมส่ง { timeout } ตรงนี้ทำให้ Authorization เพี้ยน + timeout ไม่มีผล
      return await POST(endPoint, payload);
    }
  });
};

// ต้อง await + ปล่อย error ให้ reject ออกไป ไม่กลืนไว้
// ไม่งั้นผู้เรียกจะเข้าใจว่าสำเร็จตลอด แล้วขึ้น "อัพเดตสำเร็จ" ทั้งที่ล้มเหลว
export const UseFetchUpdateInput = () => {
  return useMutation({
    mutationFn: async (payload) => await PUT(`/api/v1/input`, payload),
  });
};

export const UseFetchRejectCase = () => {
  return useMutation({
    mutationFn: async (value) => {
      const { result } = await POST(`/api/v1/input/cancelReject`, value);
      return result;
    },
  });
};

export const UseFetchReportOutput = () => {
  // ปล่อยให้ reject ขึ้นไปถึงผู้เรียก เพื่อให้แสดงข้อความจริงจาก backend
  // (เช่น "เคสนี้ถูก Report ไปแล้ว") แทนที่จะกลืน error แล้วขึ้นว่าสำเร็จ
  return useMutation(async (payload) => await POST(`/api/v1/input/reportOutput`, payload));
};